export default {
  de: 'Deutsch',
  en: 'Englisch'
}
